import { types } from 'mobx-state-tree'

const RoleModel = types.model('RoleModel', {
  id: types.optional(types.number, 0),
  name: types.maybeNull(types.string),
})

export default RoleModel
